$('.js-c-search__term__input .fa-close').on('click', function (e) {
  $(this).parent().find('input').val('')
  $(this).parents('form').trigger('submit')
  $(this).remove()
  e.preventDefault()
})
